export interface ZoneForm {
  name: string;
  type: string;
  /** Operator's explicit color pick; null means "follow the zone type's default". */
  color: string | null;
  maxAlt: string;
  alertEnabled: boolean;
}

export const INITIAL_ZONE_FORM: ZoneForm = {
  name: '',
  type: 'operational',
  color: null,
  maxAlt: '',
  alertEnabled: true,
};

export type ZoneFormAction =
  | { kind: 'patch'; patch: Partial<ZoneForm> }
  | { kind: 'reset' };

export function zoneFormReducer(state: ZoneForm, action: ZoneFormAction): ZoneForm {
  switch (action.kind) {
    case 'patch':
      return { ...state, ...action.patch };
    case 'reset':
      return INITIAL_ZONE_FORM;
  }
}
